var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEbury(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 670,
    height: 244,
    viewBox: "0 0 670 244",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M516.197 73.7692V53.584C494.929 53.584 482.464 64.0501 474.397 76.7599V53.584H430.399V73.7692H450.931V161.997H430.399H409.866V53.584H362.2V73.7692H384.2V149.287C373.2 159.006 359.266 165.738 343.868 165.738C329.202 165.738 324.068 156.762 324.068 142.556V53.584H278.602V73.7692H299.134V144.802C299.134 172.466 313.8 185.923 336.533 185.923C355.601 185.923 372.467 178.447 385.665 165.738V182.185H430.399H507.397V161.997H475.876L475.865 93.21C483.932 83.4912 497.862 73.7692 516.197 73.7692Z",
    fill: "#005066"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.5V20.6881H21.998V163.499H0V184.434H140.796V143.311H120.997V163.499H47.667V96.206H120.264V75.2681H47.667V20.6881H120.997V41.6232H140.796V0.5H0Z",
    fill: "#005066"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216.447 167.236C207.647 167.236 193.714 161.255 183.449 152.283V82.7463C192.245 76.7649 203.246 71.5304 215.714 71.5304C240.648 71.5304 250.912 91.718 250.912 117.141C250.912 142.564 243.578 167.236 216.447 167.236ZM221.58 52.0921C206.182 52.0921 193.714 57.3266 183.449 64.055V0.5H158.515V184.434H183.449V172.471C193.714 180.693 206.911 187.424 221.58 187.424C256.779 187.424 276.579 156.767 276.579 117.141C276.579 77.5147 256.779 52.0921 221.58 52.0921Z",
    fill: "#005066"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.302 20.6881H159.099V0.5H139.302V20.6881Z",
    fill: "#005066"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M516.379 73.7692H537.915V53.584H516.379V73.7692Z",
    fill: "#005066"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M607.655 53.584V73.7692H627.455L592.989 173.96L563.657 73.7692H583.457V53.584H537.991V73.7692L571.724 182.188H590.789L584.19 200.879C577.591 219.571 562.189 223.308 543.858 223.308H537.991V243.496H543.858C576.123 243.496 596.655 235.274 608.388 203.12L653.12 73.7692H669.99V53.584H607.655Z",
    fill: "#005066"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEbury);
export default __webpack_public_path__ + "static/media/ebury.e4bf40ae59291d02255e0c3314db7314.svg";
export { ForwardRef as ReactComponent };